<!--

  Implementation

  -in template:
    <expanding-object :model="Cmodel"
                        :object="customerData">
    </expanding-object>

  -import:
  import ExpandingObject from "@/components/ExpancionPanels/Generic/ExpandingObject.vue";

-->

<template>
  <slotted-expancion-panel v-if="!deleted"
                           :title="model && model.headerTitle ? model.headerTitle : null"
                           :icon="model && model.enabledIcon ? model.enabledIcon : null"
                           :helpertext="helperText"
                           :disabled="!model || !object || disabled"
                           :loading="loading">
    <template v-slot:content>
      <model-parser :model="model"
                    :object="object"
                    :loading="loading">
      </model-parser>

      <slot name="additional-content" />
      
      <v-btn v-if="model.viewMore"
             @click="viewMore()"
             class="linkStyleButton">
        {{$t('servicesystem.common_objects.document.open_in_new_tab')}}
        <v-icon size="13"
                class="pl-2">mdi-open-in-new</v-icon>
      </v-btn>
    </template>
  </slotted-expancion-panel>
</template>


<script>
import SlottedExpancionPanel from "@/views/layouts/SlottedExpancionPanel.vue";
import ModelParser from "@/components/SingleUse/ModelParser.vue";

export default {
  name: "ExpandingObject",
  props: ["model", "object", "disabled", "deleted", "loading"],
  components: { SlottedExpancionPanel, ModelParser },

  data: () => ({}),

  created() {},

  mounted() {
    
  },

  methods: {
    getValueFromKey(keychain) {
      var x = this.object;
      const keys = String(keychain).split(".");
      var returnValue = keys.reduce(function (reducedObject, potentialKey) {
        const keyValue = reducedObject ? reducedObject[potentialKey] : undefined;
        return keyValue;
      }, x || self);
      return returnValue;
    },

    viewMore() {
      let routeData = this.$router.resolve({ name: this.model.viewMore.routeName, params: this.params });
      window.open(routeData.href, "_blank");
    },
  },

  computed: {
    helperText() {
      if (this.object && this.model && this.model.listItemTextKey && this.getValueFromKey(this.model.listItemTextKey)) {
        return this.getValueFromKey(this.model.listItemTextKey);
      } else if (!this.object) {
        return "No object";
      } else if (!this.model) {
        return "No model";
      } else {
        return "";
      }
    },
    params() {
      var paramobject = this.model.viewMore.params;
      for (const [key, value] of Object.entries(paramobject)) {
        paramobject[key] = this.getValueFromKey(value);
      }
      return paramobject;
    },
  },
};
</script>